// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interval-picker-dialog {
  padding: 0.5rem 0;
}

/* Календарь */
.interval-picker-dialog__calendar-wrapper {
  display: flex;
  justify-content: center;
}

.interval-picker-dialog__calendar {
  width: 100% !important;
}

.interval-picker-dialog__calendar :global(.p-calendar) {
  width: 100% !important;
}

.interval-picker-dialog__calendar :global(.p-datepicker) {
  width: 100% !important;
  border: none !important;
  box-shadow: none !important;
}

/* Интервалы */
.interval-picker-dialog__intervals-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0 0.25rem;
}

.interval-picker-dialog__intervals-date {
  font-weight: 600;
  color: #495057;
  font-size: 0.95rem;
}

.interval-picker-dialog__intervals-count {
  font-size: 0.85rem;
  color: #6c757d;
}

.interval-picker-dialog__intervals-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 220px;
  overflow-y: auto;
  padding: 0.25rem 0;
}

.interval-picker-dialog__interval-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0.75rem;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.2s;
  background: #ffffff;
}

.interval-picker-dialog__interval-item:hover {
  background: #e3f2fd;
  border-color: #90caf9;
}

.interval-picker-dialog__interval-item--selected {
  background: #e3f2fd !important;
  border-color: #2196f3 !important;
}

.interval-picker-dialog__interval-time {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

.interval-picker-dialog__interval-status {
  display: flex;
  align-items: center;
}

.interval-picker-dialog__interval-checked {
  color: #4caf50;
  font-size: 1.1rem;
}

/* Состояния */
.interval-picker-dialog__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2rem;
  color: #6c757d;
}

.interval-picker-dialog__error {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.5rem;
  color: #f44336;
  background: #ffebee;
  border-radius: 6px;
  margin-top: 0.5rem;
}

.interval-picker-dialog__no-intervals {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.5rem;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 6px;
  margin-top: 0.5rem;
}

.interval-picker-dialog__filter-info {
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
  padding: 0.5rem 0.75rem;
  background: #e3f2fd;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #1565c0;
}

/* Адаптивность */
@media (max-width: 768px) {
  .interval-picker-dialog__intervals-list {
    max-height: 180px;
  }

  .interval-picker-dialog__interval-item {
    padding: 0.4rem 0.5rem;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .interval-picker-dialog__interval-time {
    font-size: 0.85rem;
  }

  .interval-picker-dialog__filter-info {
    font-size: 0.75rem;
    padding: 0.4rem 0.5rem;
  }
}

/* Скроллбар */
.interval-picker-dialog__intervals-list::-webkit-scrollbar {
  width: 4px;
}

.interval-picker-dialog__intervals-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.interval-picker-dialog__intervals-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.interval-picker-dialog__intervals-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.interval-picker-dialog__interval-item--from-form {
  border: 1px solid #2196f3 !important;
  background-color: #f0f7ff !important;
}

.task-card__field-input{
  height: 42px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/custom-controls/styles/IntervalPickerDialog.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".interval-picker-dialog {\n  padding: 0.5rem 0;\n}\n\n/* Календарь */\n.interval-picker-dialog__calendar-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.interval-picker-dialog__calendar {\n  width: 100% !important;\n}\n\n.interval-picker-dialog__calendar :global(.p-calendar) {\n  width: 100% !important;\n}\n\n.interval-picker-dialog__calendar :global(.p-datepicker) {\n  width: 100% !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n/* Интервалы */\n.interval-picker-dialog__intervals-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  padding: 0 0.25rem;\n}\n\n.interval-picker-dialog__intervals-date {\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.95rem;\n}\n\n.interval-picker-dialog__intervals-count {\n  font-size: 0.85rem;\n  color: #6c757d;\n}\n\n.interval-picker-dialog__intervals-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 0.25rem 0;\n}\n\n.interval-picker-dialog__interval-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.6rem 0.75rem;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #ffffff;\n}\n\n.interval-picker-dialog__interval-item:hover {\n  background: #e3f2fd;\n  border-color: #90caf9;\n}\n\n.interval-picker-dialog__interval-item--selected {\n  background: #e3f2fd !important;\n  border-color: #2196f3 !important;\n}\n\n.interval-picker-dialog__interval-time {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  color: #495057;\n}\n\n.interval-picker-dialog__interval-status {\n  display: flex;\n  align-items: center;\n}\n\n.interval-picker-dialog__interval-checked {\n  color: #4caf50;\n  font-size: 1.1rem;\n}\n\n/* Состояния */\n.interval-picker-dialog__loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 2rem;\n  color: #6c757d;\n}\n\n.interval-picker-dialog__error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1.5rem;\n  color: #f44336;\n  background: #ffebee;\n  border-radius: 6px;\n  margin-top: 0.5rem;\n}\n\n.interval-picker-dialog__no-intervals {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1.5rem;\n  color: #6c757d;\n  background: #f8f9fa;\n  border-radius: 6px;\n  margin-top: 0.5rem;\n}\n\n.interval-picker-dialog__filter-info {\n  display: flex;\n  align-items: center;\n  margin-top: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  background: #e3f2fd;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  color: #1565c0;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .interval-picker-dialog__intervals-list {\n    max-height: 180px;\n  }\n\n  .interval-picker-dialog__interval-item {\n    padding: 0.4rem 0.5rem;\n    flex-wrap: wrap;\n    gap: 0.25rem;\n  }\n\n  .interval-picker-dialog__interval-time {\n    font-size: 0.85rem;\n  }\n\n  .interval-picker-dialog__filter-info {\n    font-size: 0.75rem;\n    padding: 0.4rem 0.5rem;\n  }\n}\n\n/* Скроллбар */\n.interval-picker-dialog__intervals-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.interval-picker-dialog__intervals-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 2px;\n}\n\n.interval-picker-dialog__intervals-list::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 2px;\n}\n\n.interval-picker-dialog__intervals-list::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.interval-picker-dialog__interval-item--from-form {\n  border: 1px solid #2196f3 !important;\n  background-color: #f0f7ff !important;\n}\n\n.task-card__field-input{\n  height: 42px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
